export interface LoadingStateProps {
  title?: string;
  description?: string;
}

export function LoadingState({ title = 'Carregando...', description }: LoadingStateProps) {
  return (
    <div className="loading-state">
      <div className="loading-state__row">
        <div className="loading" />
        <div className="loading-state__title">{title}</div>
      </div>
      {description ? <div className="loading-state__desc">{description}</div> : null}
    </div>
  );
}
